// extracted by mini-css-extract-plugin
module.exports =  {"card-footer":"L6T1vX2","cardFooter":"L6T1vX2"};